import script from "./colorcardStock.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardStock.vue?vue&type=script&setup=true&lang=js"

import "./colorcardStock.vue?vue&type=style&index=0&id=1e83403e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e83403e"]])

export default __exports__